import { useEffect, useRef } from "react";
import { useLocation } from "@tanstack/react-router";
import { pushDataLayer } from "@/lib/gtm";

/**
 * Skickar en `page_view`-händelse till dataLayer vid varje klientnavigering.
 * GTM:s standardtrigger "Page View" körs bara vid första sidladdningen i en
 * SPA, så utan detta får GA4 endast en sidvisning per session.
 */
const GtmPageView = () => {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = `${location.pathname}${location.searchStr || ""}`;
    if (lastPath.current === path) return;
    const isFirst = lastPath.current === null;
    lastPath.current = path;
    // Första sidvisningen hanteras av GTM:s egen Page View-trigger.
    if (isFirst) return;
    pushDataLayer("page_view", {
      page_path: path,
      page_location: typeof window !== "undefined" ? window.location.href : path,
      page_title: typeof document !== "undefined" ? document.title : undefined,
    });
  }, [location.pathname, location.searchStr]);

  return null;
};

export default GtmPageView;
